import axios from 'axios';
import {
    VIDEO_PLAYER_CREATE_FAIL,
    VIDEO_PLAYER_CREATE_REQUEST,
    VIDEO_PLAYER_CREATE_SUCCESS,
    VIDEO_PLAYER_DELETE_FAIL,
    VIDEO_PLAYER_DELETE_REQUEST,
    VIDEO_PLAYER_DELETE_SUCCESS,
    VIDEO_PLAYER_DETAILS_FAIL,
    VIDEO_PLAYER_DETAILS_REQUEST,
    VIDEO_PLAYER_DETAILS_SUCCESS,
    VIDEO_PLAYER_LIST_FAIL,
    VIDEO_PLAYER_LIST_REQUEST,
    VIDEO_PLAYER_LIST_SUCCESS,
    VIDEO_PLAYER_LOG_DATES_FAIL,
    VIDEO_PLAYER_LOG_DATES_REQUEST,
    VIDEO_PLAYER_LOG_DATES_SUCCESS,
    VIDEO_PLAYER_LOG_FOR_DATE_FAIL,
    VIDEO_PLAYER_LOG_FOR_DATE_REQUEST,
    VIDEO_PLAYER_LOG_FOR_DATE_SUCCESS, VIDEO_PLAYER_RESTART_FAIL, VIDEO_PLAYER_RESTART_REQUEST, VIDEO_PLAYER_RESTART_SUCCESS,
    VIDEO_PLAYER_UPDATE_DETAILS_FAIL,
    VIDEO_PLAYER_UPDATE_DETAILS_REQUEST,
    VIDEO_PLAYER_UPDATE_DETAILS_SUCCESS
} from '../constants/videoPlayerConstants';

export const listVideoPlayers = (id, flag) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_LIST_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        let url = '/api/video_players';
        if(userInfo.isAdmin && flag === 'all'){
            url = `/api/video_players/admin/${id}`
        }
        const {data} = await axios.get(url, config);
        console.log(data);

        dispatch({type: VIDEO_PLAYER_LIST_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_LIST_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listVideoPlayerDetails = (id) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_DETAILS_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.get(`/api/video_players/${id}`, config);

        dispatch({type: VIDEO_PLAYER_DETAILS_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const updateVideoPlayerDetails = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_UPDATE_DETAILS_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.put(`/api/video_players/${player._id}`, player, config);

        dispatch({type: VIDEO_PLAYER_UPDATE_DETAILS_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_UPDATE_DETAILS_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const createVideoPlayer = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_CREATE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.post(`/api/video_players`, player, config);

        dispatch({type: VIDEO_PLAYER_CREATE_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_CREATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteVideoPlayer = (player) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_DELETE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };

        const {data} = await axios.delete(`/api/video_players/${player._id}`, config);

        dispatch({type: VIDEO_PLAYER_DELETE_SUCCESS, payload: data});

    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_DELETE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listVideoPlayerLogDates = (id) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_LOG_DATES_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/players/logdates`, {"playerId": id}, config);

        dispatch({type: VIDEO_PLAYER_LOG_DATES_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_LOG_DATES_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const listVideoPlayerLogForDate = (id, date) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_LOG_FOR_DATE_REQUEST});

        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/players/logs`, {"playerId": id, "date": date}, config);

        dispatch({type: VIDEO_PLAYER_LOG_FOR_DATE_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_LOG_FOR_DATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const restartVideoPlayer = (pin) => async (dispatch, getState) => {
    try {
        dispatch({type: VIDEO_PLAYER_RESTART_REQUEST});
        console.log('restarting');
        const {
            userLogin: {userInfo},
        } = getState();

        const config = {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.token}`,
            },
        };
        const {data} = await axios.post(`/api/restart/${pin}`, {"playerPin": pin}, config);

        console.log('restart over');
        dispatch({type: VIDEO_PLAYER_RESTART_SUCCESS, payload: data});
    } catch (error) {
        dispatch({
            type: VIDEO_PLAYER_RESTART_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
